import React from 'react';
import { Nav, Navbar, NavDropdown, Container } from 'react-bootstrap';
import '../style.css';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const NavigationBar = ({ domains = [], selectedDomain, handleDomainChange }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname;

    return (
        <Navbar className="navbar-custom sticky-top shadow-sm border-bottom" expand="lg">
            <Container>
                <Navbar.Brand 
                    className="navbar-brand-custom" 
                    onClick={() => navigate('/')} 
                    style={{ cursor: 'pointer' }}>
                    <span>WowGuide</span>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-lg-auto d-flex flex-column flex-lg-row justify-content-lg-end gap-2 gap-lg-4 align-items-lg-center">
                        <NavDropdown 
                            title={selectedDomain ? selectedDomain.domain_name : "Select Domain"} 
                            id="nav-dropdown-domain"
                            className="nav-dropdown-custom me-lg-2"
                            style={{ fontWeight: '600', color: '#4f46e5' }}
                        >
                            {domains.map(d => (
                                <NavDropdown.Item 
                                    key={d.id} 
                                    onClick={() => handleDomainChange(d)}
                                    active={selectedDomain && selectedDomain.id === d.id}
                                >
                                    {d.domain_name}
                                </NavDropdown.Item>
                            ))}
                        </NavDropdown>

                        <NavDropdown 
                            title="Search Models" 
                            id="nav-dropdown-search"
                            className={`nav-dropdown-custom ${path.startsWith('/search') ? 'active-dropdown' : ''}`}
                        >
                            <NavDropdown.Item as={Link} to="/search/gemini" active={path === '/search/gemini'}>
                                Gemini AI
                            </NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/search/qwen" active={path === '/search/qwen'}>
                                Qwen 
                            </NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item as={Link} to="/search/ximilar" active={path === '/search/ximilar'}>
                                Ximilar
                            </NavDropdown.Item>
                        </NavDropdown>

                        <Nav.Link 
                            as={Link} 
                            to="/collection" 
                            className={`nav-link-custom ${path === '/collection' ? 'active-link' : ''}`}
                        >
                            Collection
                        </Nav.Link>
                        <Nav.Link 
                            as={Link} 
                            to="/review" 
                            className={`nav-link-custom ${path === '/review' ? 'active-link' : ''}`}
                        >
                            Review Page
                        </Nav.Link>
                        <Nav.Link 
                            as={Link} 
                            to="/activities" 
                            className={`nav-link-custom ${path === '/activities' ? 'active-link' : ''}`}
                        >
                            Activities
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default NavigationBar;
